<div>
    <mat-card>

        <mat-card-header>
            <mat-card-title>
                <h1>404 - Page Not Found</h1>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <p>
                You have been diverted to a landfill. Please check your waste bin to see if you can be directed to a more environmentally friendly end use.
            </p>
        </mat-card-content>

        <mat-card-actions>
            <button mat-stroked-button routerLink="/">Home</button>
        </mat-card-actions>

    </mat-card>
</div>
